import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Divider/divider';
export var DividerVariant;

(function (DividerVariant) {
  DividerVariant["hr"] = "hr";
  DividerVariant["li"] = "li";
  DividerVariant["div"] = "div";
})(DividerVariant || (DividerVariant = {}));

export var Divider = function Divider(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? DividerVariant.hr : _a$component,
      _a$isVertical = _a.isVertical,
      isVertical = _a$isVertical === void 0 ? false : _a$isVertical,
      props = __rest(_a, ["className", "component", "isVertical"]);

  var Component = component;
  return React.createElement(Component, Object.assign({
    className: css(styles.divider, isVertical && styles.modifiers.vertical, className)
  }, component !== 'hr' && {
    role: 'separator'
  }, props));
};